<template>
	<div class="ui-tag" v-on="$listeners" :class="[color]" :style="{ color: text }">
		<slot :style="{ color: text }" />
	</div>
</template>

<script>
export default {
	name: 'uiTag',
	props: {
		text: {
			type: String,
			default: 'white',
		},
		color: {
			type: String,
			default: 'accent',
		},
	},
}
</script>

<style lang="less" scoped>
@import '../../assets/app.less';

.ui-tag {
	padding: 1px 10px;
	display: inline-block;
	border-radius: 999px;
	background: #fff;
	font-size: 12px;
	font-weight: 600;

	&.accent {
		background: @accent;
	}
	&.green {
		background: @green;
	}
	&.yellow {
		background: @yellow;
	}
	&.red {
		background: @red;
	}
}
</style>
